<script>

export default {

  name: 'MoreInfo',

  props: {
    intro: {
      type: Object,
      default: null
    }
  },

  computed: {
    logo() {
      return this.teamsiteConfig.alternative_logo || this.teamsiteConfig.logo
    }
  }

}

</script>

<template>
  <div class="more-info" v-if="intro && logo" :style="{'background-color': teamsiteConfig.color}">
    <div class="row">
      <div class="columns small-offset-1 small-22">
        <div class="row">

          <div class="columns medium-12">
            <h2 v-html="intro.title"></h2>
            <p v-html="intro.body"></p>
          </div>

          <div class="columns medium-12 image-wrapper">
            <div class="row">
              <div class="columns medium-18 team-image" v-if="logo && intro.car_image">
                <img :src="logo.url"/>
              </div>

              <div class="columns medium-21 medium-offset-3 team-image-single text-center" v-else-if="logo">
                <img :src="logo.url"/>
              </div>

              <div class="columns medium-18 car-image" v-if="intro.car_image">
                <img :src="intro.car_image.url"/>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h2, p {
  color: white;
}
h2 {
  font-size: rem-calc(45);
  @include breakpoint(small only) {
    font-size: rem-calc(30);
    line-height: rem-calc(40);
  }
}
p {
  font-size: rem-calc(22);
  @include breakpoint(small only) {
    font-size: rem-calc(18);
    line-height: rem-calc(30);
  }
}
.more-info {
  padding-top: rem-calc(50);
}
.image-wrapper {
  position: relative;
  min-height: 400px;
}
.team-image-single {
  img {
    max-height: 250px;
  }
}
.team-image {
  max-width: 200px;
  margin-left: 40px;
}
.car-image {
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MoreInfo.vue